import ContentCard from "../../../components/misc/ContentCard";
import CustomButton from "../../../components/CustomButton";
import ExpeditionScheduleRoutes from "../ScheduleWorkingRoutes";
import { expeditionRoutes } from "../../../router/routesConstants";
import { useNavigate } from "react-router-dom";

function RoutesOrganizationLocal() {
  const navigate = useNavigate();
  const handleButtonPress = () => {
    navigate(`/${expeditionRoutes.routesOrganizationInternode}`);
  };

  return (
    <>
      <ContentCard cardBodyClassName="d-flex">
        <CustomButton
          variant={"contained"}
          style={{ borderEndEndRadius: 0, borderStartEndRadius: 0 }}
          fullWidth>
          Rute locale
        </CustomButton>
        <CustomButton
          variant={"outlined"}
          style={{ borderEndStartRadius: 0, borderStartStartRadius: 0 }}
          fullWidth
          onClick={handleButtonPress}>
          Rute internod
        </CustomButton>
      </ContentCard>
      <ExpeditionScheduleRoutes />
    </>
  );
}

export default RoutesOrganizationLocal;
